import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["password", "toggle"];
  connect() {
    this.updateIcon();
  }

  toggle() {
    const type = this.passwordTarget.type === "password" ? "text" : "password";
    this.passwordTarget.type = type;
    this.updateIcon();
  }

  updateIcon() {
    this.toggleTarget.innerHTML =
      this.passwordTarget.type === "password"
        ? `<svg width="22" height="18" viewBox="0 0 22 18" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.02051 9.322C0.951497 9.11459 0.951497 8.89041 1.02051 8.683C2.40751 4.51 6.34451 1.5 10.9845 1.5C15.6225 1.5 19.5575 4.507 20.9475 8.678C21.0175 8.885 21.0175 9.109 20.9475 9.317C19.5615 13.49 15.6245 16.5 10.9845 16.5C6.34651 16.5 2.41051 13.493 1.02051 9.322Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.9844 9C13.9844 9.79565 13.6683 10.5587 13.1057 11.1213C12.5431 11.6839 11.78 12 10.9844 12C10.1887 12 9.42566 11.6839 8.86305 11.1213C8.30045 10.5587 7.98438 9.79565 7.98438 9C7.98438 8.20435 8.30045 7.44129 8.86305 6.87868C9.42566 6.31607 10.1887 6 10.9844 6C11.78 6 12.5431 6.31607 13.1057 6.87868C13.6683 7.44129 13.9844 8.20435 13.9844 9Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`
        : `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-off">
        <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"/>
        <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"/>
        <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"/>
        <path d="m2 2 20 20"/>
      </svg>`;
  }
}
